export enum UsersRoutePath {
    Users = '/users',
    Geolocation = '/users/geolocation',
    Analytic = '/users/analytic'
}
